import { FunctionComponent } from 'react'
import { Flyout } from '~/components/Flyout'

export const PureAdmAdUnitHelpFlyout: FunctionComponent = () => {
  return (
    <Flyout.Content>
      <Flyout.Title>Help</Flyout.Title>
      <Flyout.Body>
        <div className="[&_h2]:pt-6 [&_h2]:pb-3">
          <h2>How to connect ad units to the ad management system?</h2>
          <p>1. Click on “Add ad unit”.</p>
          <p>2. Define the ad unit and settings in the form.</p>
          <h2>Why should I add the ad units to the inventory?</h2>
          <p>To monetise ad units with the ad management, they must be declared.</p>
          <h2>Can I use one ad unit on several sites?</h2>
          <p>One ad unit can be used for one or several sites as long as the technical ID (or div ID) is the same on each site.</p>
          <br />
          <p>If you need an ad unit to have a specific behaviour for one context or site, we recommend to create a new one, which can have the same technical ID as another ad unit. </p>
        </div>
      </Flyout.Body>
    </Flyout.Content>
  )
}
